import { merge } from '@/utils/util';

export const getDefaultAlertOptions = (type = 'alert') => ({
  type,
  show: false,
  message: '',
  title: '알림',
  confirmButtonText: '확인',
  cancelButtonText: '취소',
  useCancel: false,
  snackbarType: 'info',
  duration: 2500,
  callback: null,
  param: null,
});

export const getProps = (options = {}) => {
  if (!['object', 'string'].includes(typeof options)) return;
  const props = typeof options === 'string' ? { message: options } : options;
  return merge(getDefaultAlertOptions(), { show: true, ...props });
};
